module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('pageheader', {
    attrs: {
      "default-index": _vm.defaultItem,
      "user-info": _vm.getUserInfo,
      "app-info": true
    },
    on: {
      "logout": _vm.logout,
      "changeLang": _vm.switchLang
    }
  }), _vm._v(" "), _c('pagesidebar', {
    attrs: {
      "default-index": _vm.defaultItem
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-container"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    staticClass: "mp-height-add"
  })], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-03297a65", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03297a65"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Authorized.vue
// module id = 593
// module chunks = 21